import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetTableOrdersQuery } from "../slices/tableSlice";
import { Col, Row, Table } from "react-bootstrap";
import { LayoutSidebarReverse } from "react-bootstrap-icons";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { formatAmount } from "../utils/commonUtils";

const TableOrdersScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);

  const [selectedTableId, setSelectedTableId] = useState(null);

  const {
    data: tableOrders,
    isLoading,
    refetch,
    error,
  } = useGetTableOrdersQuery({ token: userInfo.token });

  const tableMap = new Map();

  if (Array.isArray(tableOrders)) {
    tableOrders.forEach((orderEntry) => {
      const key = `${orderEntry.floor}-${orderEntry.tableNumber}`;

      if (!tableMap.has(key)) {
        tableMap.set(key, {
          tableId: orderEntry._id,
          floor: orderEntry.floor,
          tableNumber: orderEntry.tableNumber,
          tableStatus: orderEntry.tableStatus,
          deliveryOtp: orderEntry.deliveryOtp,
          allOrders: [],
        });
      }

      const table = tableMap.get(key);
      if (orderEntry.currentOrderId?.length > 0) {
        table.allOrders.push(...orderEntry.currentOrderId);
      }
    });
  }

  const tableList = Array.from(tableMap.values());

  useEffect(() => {
    if (!selectedTableId && tableList.length > 0) {
      setSelectedTableId(tableList[0].tableId);
    }
  }, [tableList]);

  const selectedTable = tableList.find(
    (table) => table.tableId === selectedTableId
  );

  const filteredOrders = [];

  if (selectedTable?.allOrders?.length) {
    selectedTable.allOrders.forEach((order) => {
      const itemNames = order.orderDetails
        .map(
          (item) =>
            `${item.itemName}${
              item.itemQuantity > 1 ? ` (${item.itemQuantity})` : ""
            }`
        )
        .join(", ");

      const totalCount = order.orderDetails.reduce(
        (sum, item) => sum + item.itemQuantity,
        0
      );

      const totalAmount = order.orderDetails.reduce(
        (sum, item) => sum + item.sellingPriceAfterOffers * item.itemQuantity,
        0
      );

      filteredOrders.push({
        orderId: order._id,
        itemNames,
        count: totalCount,
        tableStatus: selectedTable.tableStatus,
        deliveryOtp: order.deliveryOtp || selectedTable.deliveryOtp,
        amount: totalAmount,
        time: new Date(order.createdAt).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      });
    });
  }

  return (
    <>
      <label>Table Orders</label>
      <Row className="p-3">
        {/* Left: Orders Table */}
        <Col md={2}>
          <h6>Select Table below</h6>
          <Row>
            {tableList.map((table) => (
              <div
                className={`secondaryButton`}
                onClick={() => setSelectedTableId(table.tableId)}
                style={{
                  cursor: "pointer",
                  padding: "0.3rem",
                  backgroundColor:
                    table?.tableStatus !== "Occupied" && "#83c8f6",
                  border:
                    selectedTableId === table.tableId
                      ? "0.2rem solid orange"
                      : "",
                  borderRadius: "10px",
                  margin: "0.4rem",
                }}
              >
                {table.floor} Floor - Table {table.tableNumber}
              </div>
            ))}
          </Row>
        </Col>
        <Col md={8}>
          {isLoading ? (
            <Loader />
          ) : error ? (
            <Message>{error?.data?.error}</Message>
          ) : (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Order Id</th>
                  <th>Names</th>
                  <th>Count</th>
                  <th>Status</th>
                  <th>OTP</th>
                  <th>Amount</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrders.map((order, index) => (
                  <tr key={`${order.orderId}-${index}`}>
                    <td>{order.orderId}</td>
                    <td>{order.itemNames}</td>
                    <td>{order.count}</td>
                    <td>{order.tableStatus}</td>
                    <td>{order.deliveryOtp}</td>
                    <td>{formatAmount(order.amount)}</td>
                    <td>{order.time}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Col>

        {/* Right: Table Selector */}
      </Row>
    </>
  );
};

export default TableOrdersScreen;
